import { Fragment, useEffect } from "react";
import {
	Box,
	Container,
	Divider,
	Typography,
	Tooltip,
	IconButton,
	Button,
	InputLabel,
	FilledInput,
	FormControl,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useCart } from "../../context/Cart/CartContext.jsx";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "./PasswordChange.css";

function PasswordChange(props) {
	const { cart } = useCart();
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Fragment>
			<Container>
				<Box display="flex" alignItems="center" minHeight="56px">
					<Box>
						<Tooltip title="Volver">
							<IconButton
								size="large"
								aria-label="volver"
								aria-controls="volver-carrito"
								aria-haspopup="false"
								color="inherit"
								onClick={() => navigate(-1)}
							>
								<ArrowBackIosIcon />
							</IconButton>
						</Tooltip>
					</Box>
					<Typography
						variant="h5"
						display="flex"
						justifyContent="center"
						alignItems="center"
						flexGrow={1}
					>
						Cambio de Contraseña
					</Typography>
					<Box>
						<Tooltip title="Carrito">
							<Link to="/cart">
								<IconButton
									size="large"
									aria-label="carrito"
									aria-controls="logo-carrito"
									aria-haspopup="false"
									color="inherit"
								>
									{cart?.length > 0 ? (
										<ShoppingBagIcon color="secondary" />
									) : (
										<ShoppingBagOutlinedIcon color="secondary" />
									)}
								</IconButton>
							</Link>
						</Tooltip>
					</Box>
				</Box>
			</Container>
			<Divider />
			<Container>
				<Box className="boxAddressShippingContainer" my={1} pt={2}>
					<Typography className="titleFirstRow" sx={{ fontWeight: "600" }}>
						Cambio de Contraseña
					</Typography>
				</Box>
				<Divider />
				<Box
					component="form"
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						input: {
							background: "#f8f9fa",
						},
					}}
					noValidate
					autoComplete="off"
					style={{ marginBottom: "20px", marginTop: "10px" }}
				>
					{props.passwordFields?.map((field) => (
						<div key={field.id} style={{ width: "100%" }}>
							<FormControl sx={{ width: "100%" }} variant="filled">
								<InputLabel htmlFor={field.label} className="MuiFormLabel-root">
									{field.label}
								</InputLabel>
								<FilledInput
									className="MuiInputBase-root-MuiFilledInput-root"
									style={{ background: "#f8f9fa" }}
									color="success"
									id={field.id}
									name={field.name}
									value={field.value}
									onChange={(e) => props.handleChange(e)}
									type={field.showPassword ? "text" : "password"}
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={() => props.handleClickShowPassword(field.id)}
												edge="end"
											>
												{field.showPassword ? (
													<VisibilityOff />
												) : (
													<Visibility />
												)}
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>
							<Typography
								sx={{ textAlign: "left", height: 25, mb: 1 }}
								variant="body1"
								color="error"
							>
								{field.error}
							</Typography>
						</div>
					))}
					<Button
						variant="contained"
						color="secondary"
						sx={{ marginTop: "2rem", marginBottom: "2rem" }}
						onClick={props.handleSubmit}
					>
						Guardar cambio
					</Button>
				</Box>
			</Container>
		</Fragment>
	);
}

export default PasswordChange;
